if (!customElements.get('ly-quantity-input')) {
    customElements.define('ly-quantity-input', class extends HTMLElement {

        connectedCallback() {
            this.changeEvent = new Event('change', { bubbles: true })
            this.input = this.querySelector('input')
            this.minusButton = this.querySelector('button[name="minus"]')
            this.plusButton = this.querySelector('button[name="plus"]')

            this.validateQtyRules()

            this.input.addEventListener('change', this.validateQtyRules)

            this.minusButton.addEventListener('click', this.clickHandler)
            this.plusButton.addEventListener('click', this.clickHandler)
        }

        disconnectedCallback() {
            this.input.removeEventListener('change', this.validateQtyRules)

            this.minusButton.removeEventListener('click', this.clickHandler)
            this.plusButton.removeEventListener('click', this.clickHandler)
        }

        validateQtyRules = () => {
            const value = parseInt(this.input.value)
            if (this.input.min) {
                const min = parseInt(this.input.min)
                this.minusButton.disabled = value <= min
                if (value < min) this.input.value = min
            }
            if (this.input.max) {
                const max = parseInt(this.input.max)
                this.plusButton.disabled = value >= max
                if (value > max) this.input.value = max
            } else {
                this.plusButton.disabled = false
            }
        }

        clickHandler = (evt) => {
            evt.preventDefault()

            const previousValue = this.input.value

            if (evt.currentTarget.name === 'plus') {
                this.input.stepUp()
            } else {
                this.input.stepDown()
            }

            if (previousValue !== this.input.value) {
                this.input.dispatchEvent(this.changeEvent)
            }
        }
    })
}